(() => {
  if (navigator.globalPrivacyControl || window.ssMarketingConsentSync) return;
  window.ssMarketingConsentSync = true;

  let featureRequested = false;
  let queued = false;
  let pending = false;
  let failedState;

  function privacyApi() {
    const api = window.Shopify?.customerPrivacy;
    if (typeof api?.setTrackingConsent !== 'function' || typeof api.currentVisitorConsent !== 'function') return;
    return api;
  }

  function currentChoice() {
    try {
      const current = privacyApi()?.currentVisitorConsent();
      if (current?.marketing === 'yes' || current?.marketing === 'no') return current;
    } catch {}
  }

  function scheduleReconcile() {
    if (queued || navigator.globalPrivacyControl) return;
    queued = true;
    setTimeout(() => {
      queued = false;
      reconcile();
    }, 0);
  }

  function reconcile() {
    if (navigator.globalPrivacyControl || pending) return;
    const api = privacyApi();
    const current = currentChoice();
    if (!api || !current || current.sale_of_data === current.marketing) return;
    const state = `${current.marketing}:${current.sale_of_data}`;
    if (state === failedState) return;

    pending = true;
    let settled = false;
    const complete = (error) => {
      if (settled) return;
      settled = true;
      pending = false;
      failedState = error ? state : undefined;
      if (!error) scheduleReconcile();
    };

    try {
      const result = api.setTrackingConsent({ sale_of_data: current.marketing === 'yes' }, complete);
      if (typeof result?.then === 'function') result.then(() => complete(), complete);
    } catch (error) {
      complete(error);
    }
  }

  function patchConsentWriter(api) {
    if (api.setTrackingConsent.ssMarketingConsentSync) return;
    const original = api.setTrackingConsent;
    function setTrackingConsent(consent, callback) {
      let payload = consent;
      if (!navigator.globalPrivacyControl && payload && typeof payload === 'object' &&
          typeof payload.marketing === 'boolean' && typeof payload.sale_of_data === 'undefined') {
        payload = { ...payload, sale_of_data: payload.marketing };
      }
      return original.call(this, payload, callback);
    }
    setTrackingConsent.ssMarketingConsentSync = true;
    api.setTrackingConsent = setTrackingConsent;
  }

  function initialize() {
    if (navigator.globalPrivacyControl) return;
    const api = privacyApi();
    if (api) {
      patchConsentWriter(api);
      reconcile();
      return;
    }
    if (featureRequested || typeof window.Shopify?.loadFeatures !== 'function') return;
    featureRequested = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (error) featureRequested = false;
        else initialize();
      });
    } catch {
      featureRequested = false;
    }
  }

  document.addEventListener('visitorConsentCollected', () => {
    failedState = undefined;
    scheduleReconcile();
  });
  document.addEventListener('consentTrackingApiLoaded', initialize);
  initialize();

  let attempts = 0;
  const poll = setInterval(() => {
    initialize();
    const current = currentChoice();
    if (navigator.globalPrivacyControl || (current && current.sale_of_data === current.marketing && !pending) || ++attempts >= 120) {
      clearInterval(poll);
    }
  }, 500);
})();
